// extracted by mini-css-extract-plugin
module.exports =  {"titleWithDetails":"Cg4zFEiB4eEI3wpFRJi_","title":"etSkTbcCHykAfTHUW6gR","label":"veih29etupuZx0ThpPXE","carousel":"HjdW1bJ5nXrDQXLrzmnm"};